import { getAPIRoute } from './common';

const API_ROUTE_WITHDRAW_DEPOSIT = process.env.REACT_APP_ENV_API_ROUTE_WITHDRAW_DEPOSIT;
export const SANDRA_JS_API = process.env.REACT_APP_ENV_SANDRA_JS_API;

export const POST_DATA_GRAPH = `${getAPIRoute()}jwi/datagraph/entity`;
export const ACTIVE_BLOCKCHAINS = `${getAPIRoute()}config/getActiveBlockchains`;
export const TRANSACTIONS_URL = `${getAPIRoute()}events/`;

export const WITHDRAW_ALL = `${API_ROUTE_WITHDRAW_DEPOSIT}withdraw/all`;
export const WITHDRAW_FAIL = `${API_ROUTE_WITHDRAW_DEPOSIT}withdraw/fail`;
export const WITHDRAW_REFUNDED = `${API_ROUTE_WITHDRAW_DEPOSIT}withdraw/refunded`;

export const DEPOSIT_ALL = `${API_ROUTE_WITHDRAW_DEPOSIT}deposit/all`;
export const DEPOSIT_FAIL = `${API_ROUTE_WITHDRAW_DEPOSIT}deposit/fail`;
export const POST_REFUND_DEPOSIT = `${API_ROUTE_WITHDRAW_DEPOSIT}deposit/refund`;
export const POST_RETRY_DEPOSIT = `${API_ROUTE_WITHDRAW_DEPOSIT}deposit/retry`;
export const POST_REFUEL_DEPOSIT = `${API_ROUTE_WITHDRAW_DEPOSIT}deposit/restart`;
export const POST_TEST_DEPOSIT = `${API_ROUTE_WITHDRAW_DEPOSIT}deposit/test`;
export const POST_REFUND_WITHDRAW = `${API_ROUTE_WITHDRAW_DEPOSIT}withdraw/refund`;

// Sandra JS API
export const GET_ASSETS_BY_QUERY = `${SANDRA_JS_API}graph/asset/custom/filter`;
export const GET_ASSET_BINDINGS_BY_QUERY = `${SANDRA_JS_API}graph/asset/custom/bindings`;

export const GET_TOKEN_BINDINGS = `${SANDRA_JS_API}graph/token/contracts/`;

export const GET_ASSET = `${SANDRA_JS_API}graph/asset/`;
export const UPDATE_EXTENDED_ASSET = `${SANDRA_JS_API}graph/asset/extend/`;
export const GET_COLLECTIONS_URL = `${SANDRA_JS_API}graph/collection/list/`;
export const GET_COLLECTION_DETAILS = `${SANDRA_JS_API}graph/collection/`;
export const ADD_CONTRACT = `${SANDRA_JS_API}graph/contract/add`;
export const CONTRACT_URL = `${SANDRA_JS_API}graph/contract/`;
export const ADD_COLLECTION = `${SANDRA_JS_API}graph/collection`;
export const ADD_PROCESS = `${SANDRA_JS_API}graph/process/add`;
export const GET_PROCESS_LIST = `${SANDRA_JS_API}graph/process/all`;
export const GET_PROCESS_DETAILS = `${SANDRA_JS_API}graph/process/`;
export const DO_PROCESS_ACTION = `${SANDRA_JS_API}graph/process/action`;
export const ADD_PROCESS_CONTRACT = `${SANDRA_JS_API}graph/process/contract`;
export const GET_CONTRACT_DETAILS = `${SANDRA_JS_API}graph/contract/details/`;
export const GET_PROCESS_CONTRACT = `${SANDRA_JS_API}graph/process/contract/`;
export const UPDATE_PROCESS_CONTRACT = `${SANDRA_JS_API}graph/process/contract/`;
export const GET_PROCESS_CONTRACT_STATUS = `${SANDRA_JS_API}graph/process/contracts/status/`;
export const GET_SERVER_CONFIG = `${SANDRA_JS_API}graph/server/config/`;

export const ACTIVE_BLOCKCHAINS_BALOR = process.env.REACT_APP_ENV_ACTIVE_BLOCKCHAINS_BALOR;
export const SERVER_CHALLENGE_URL = process.env.REACT_APP_ENV_SERVER_CHALLENGE_URL;
export const SIGN_IN_URL = process.env.REACT_APP_ENV_SIGN_IN_URL;
